/* eslint-disable camelcase */
import MediaType from "nexia_mobile/framework/media_type";

const getFeatures = (
  currentTemp,
  status,
  isOccupied,
  occupancy_setpoints,
  isConnected,
  mode
) => {
  const setpointHeat = isOccupied
    ? occupancy_setpoints.preset_heat1
    : occupancy_setpoints.preset_heat2;
  const setpointCool = isOccupied
    ? occupancy_setpoints.preset_cool1
    : occupancy_setpoints.preset_cool2;
  return [
    {
      name: "unenroll",
      actions: {
        unenroll: {
          method: "POST",
          href: "xxl_thermostats/demo/unenroll",
        },
      },
    },
    {
      name: "runtime_history",
      actions: {
        get_runtime_history: {
          method: "GET",
          href: "mobile/runtime_history/737395?report_type=daily",
        },
        get_monthly_runtime_history: {
          method: "GET",
          href: "mobile/runtime_history/737395?report_type=monthly",
        },
      },
    },
    {
      name: "thermostat",
      temperature: currentTemp,
      status,
      actions: {},
      setpoint_delta: 3,
      setpoint_increment: 1,
      setpoint_heat:
        mode.value === "AUTO" || mode.value === "HEAT" ? setpointHeat : null,
      setpoint_cool:
        mode.value === "AUTO" || mode.value === "COOL" ? setpointCool : null,
      setpoint_heat_min: 55,
      setpoint_heat_max: 90,
      setpoint_cool_min: 60,
      setpoint_cool_max: 99,
      system_status: status,
      status_icon: {
        modifiers: [],
        name: status,
      },
    },
    {
      name: "connection",
      signal_strength: "unknown",
      is_connected: isConnected,
    },
    {
      name: "thermostat_mode",
      label: "System Mode",
      value: mode.value,
      display_value: mode.label,
      options: [
        {
          id: "thermostat_mode",
          label: "System Mode",
          value: "thermostat_mode",
          header: true,
        },
        {
          value: "AUTO",
          label: "Auto",
        },
        {
          value: "COOL",
          label: "Cooling",
        },
        {
          value: "HEAT",
          label: "Heating",
        },
        {
          value: "OFF",
          label: "Off",
        },
      ],
      actions: {
        update_thermostat_mode: {
          method: "POST",
          href: "xxl_zones/120996/zone_mode",
        },
      },
    },
    {
      name: "thermostat_fan_mode",
      label: "Fan Mode",
      options: [
        {
          id: "thermostat_fan_mode",
          label: "Fan Mode",
          value: "thermostat_fan_mode",
          header: true,
        },
        {
          value: "auto",
          label: "Auto",
        },
        {
          value: "on",
          label: "On",
        },
      ],
      value: "auto",
      display_value: "Auto",
      actions: {
        update_thermostat_fan_mode: {
          method: "POST",
          href: "xxl_thermostats/demo/fan_mode",
        },
      },
    },
    {
      name: "schedule",
      enabled: true,
      max_period_name_length: 10,
      collection_url:
        "schedules?device_identifier=TraneXl824c-demo&house_id=57265",
      actions: {
        get_active_schedule: {
          href:
            "thermostat_schedules/get_active_schedule?device_identifier=TraneXl824c-demo",
          method: "POST",
        },
        set_active_schedule: {
          href:
            "thermostat_schedules/set_active_schedule?device_identifier=TraneXl824c-demo",
          method: "POST",
        },
        get_default_schedule: {
          href:
            "thermostat_schedules/get_default_schedule?device_identifier=TraneXl824c-demo",
          method: "GET",
        },
      },
      can_add_remove_periods: true,
      max_periods_per_day: 6,
    },
    {
      name: "pivot",
      device_identifier: "TraneXl824c-demo",
      occupancy_mode: isOccupied ? "occupied" : "unoccupied",
      occupancy_setpoints,
      max_period_name_length: 10,
      max_periods_per_day: 6,
      high_low_temp_alert: {
        high_low_enabled: null,
        high_limit: 100,
        low_limit: 45,
      },
      sensor_fault_enabled: false,
      pin_access: {
        pin_enabled: true,
        pin_passcode: "1234",
        technican_pin_enabled: false,
        technican_passcode: "5678",
      },
      access_level: {
        access_level_type: "NONE",
      },
      actions: {
        set_occupancy_mode: {
          href: "xxl_zones/120996/commercial_preset_selected",
          method: "POST",
        },
        set_occupancy_setpoints: {
          href: "xxl_zones/120996/occupancy_setpoints",
          method: "POST",
        },
        set_group_occupancy_setpoints: {
          href: "xxl_zones/group_occupancy_setpoints",
          method: "POST",
        },
        set_group_schedule: {
          href: "thermostat_schedules/set_commercial_group_schedule",
          method: "POST",
        },
        get_schedules_with_default: {
          href:
            "thermostat_schedules/get_schedules_with_default?device_identifier=TraneXl824c-demo&house_id=57265",
          method: "GET",
        },
        set_high_low_temp_alert: {
          href: "mobile/xxl_thermostats/740802/temperature_alert",
          method: "POST",
        },
        set_group_high_low_temp_alert: {
          href: "mobile/xxl_thermostats/set_group_temperature_alerts",
          method: "POST",
        },
        set_sensor_fault_enabled: {
          href: "mobile/xxl_thermostats/740802/sensor_fault_enabled",
          method: "POST",
        },
        set_group_sensor_fault_enabled: {
          href: "mobile/xxl_thermostats/group_sensor_fault_enabled",
          method: "POST",
        },
        set_pin_access: {
          href: "mobile/xxl_thermostats/740802/set_pin_access",
          method: "POST",
        },
        set_group_pin_access: {
          href: "mobile/xxl_thermostats/set_group_pin_access",
          method: "POST",
        },
        set_access_level: {
          href: "mobile/xxl_thermostats/740802/set_access_level",
          method: "POST",
        },
        set_group_access_level: {
          href: "mobile/xxl_thermostats/set_group_access_level",
          method: "POST",
        },
      },
    },
    {
      name: "pivot_occupancy_mode",
      label: "Occupancy Mode Override",
      value: isOccupied ? "occupied" : "unoccupied",
      display_value: "Occupied",
      setpoints_override: {
        occupancy_override_mode: 0,
        setpoint_expiration_time: 2,
        setpoint_degree_limit_enabled: true,
        setpoint_degree_limit: 5,
      },
      occupancy_override: {
        occupancy_override_enabled: 0,
        occupancy_override_time: 2,
        occupancy_override_start_date: "0",
        occupancy_override_start_time: "0",
      },
      actions: {
        set_occupancy_override: {
          href: "mobile/xxl_zones/6/pivot_timed_override",
          method: "POST",
        },
      },
    },
  ];
};

const getBaseSettings = (mode) => {
  return [
    {
      type: "system_mode",
      title: "System Mode",
      options: [
        {
          value: "AUTO",
          label: "Auto",
        },
        {
          value: "COOL",
          label: "Cooling",
        },
        {
          value: "HEAT",
          label: "Heating",
        },
        {
          value: "OFF",
          label: "Off",
        },
      ],
      labels: ["Auto", "Cooling", "Heating", "Off"],
      values: ["AUTO", "COOL", "HEAT", "OFF"],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_zones/6/zone_mode",
        },
      },
      id: "http://localhost:3000/mobile/xxl_zones/6/zone_mode",
      value: mode.value,
    },
    {
      type: "scheduling_enabled",
      title: "Scheduling",
      options: [
        {
          value: true,
          label: "ON",
        },
        {
          value: false,
          label: "OFF",
        },
      ],
      labels: ["ON", "OFF"],
      values: [true, false],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_zones/6/scheduling_enabled",
        },
      },
      id: "http://localhost:3000/mobile/xxl_zones/6/scheduling_enabled",
      value: true,
    },
    {
      type: "fan_mode",
      title: "Fan Mode",
      options: [
        {
          value: "auto",
          label: "Auto",
        },
        {
          value: "on",
          label: "On",
        },
      ],
      labels: ["Auto", "On"],
      values: ["auto", "on"],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_thermostats/6/fan_mode",
        },
      },
      id: "http://localhost:3000/mobile/xxl_thermostats/6/fan_mode",
      value: "auto",
    },
    {
      type: "dehumidify",
      title: "Cooling Dehumidify Set Point",
      options: [
        {
          value: 0.35,
          label: "35%",
        },
        {
          value: 0.4,
          label: "40%",
        },
        {
          value: 0.45,
          label: "45%",
        },
        {
          value: 0.5,
          label: "50%",
        },
        {
          value: 0.55,
          label: "55%",
        },
        {
          value: 0.6,
          label: "60%",
        },
        {
          value: 0.65,
          label: "65%",
        },
      ],
      labels: ["35%", "40%", "45%", "50%", "55%", "60%", "65%"],
      values: [0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_thermostats/6/dehumidify",
        },
      },
      id: "http://localhost:3000/mobile/xxl_thermostats/6/dehumidify",
      value: 0.5,
    },
    {
      type: "scale",
      title: "Temperature Scale",
      options: [
        {
          value: "f",
          label: "F",
        },
        {
          value: "c",
          label: "C",
        },
      ],
      labels: ["F", "C"],
      values: ["f", "c"],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_thermostats/6/scale",
        },
      },
      id: "http://localhost:3000/mobile/xxl_thermostats/6/scale",
      value: "f",
    },
  ];
};
const getSettings = (isOccupied, mode) => {
  if (isOccupied) {
    return [
      {
        type: "pivot_timed_override",
        title: "Occupancy",
        options: [
          {
            value: "pivot_default_no_schedule_unoccupied",
            label: "Occupied",
          },
        ],
        labels: ["Occupied"],
        values: ["pivot_default_no_schedule_unoccupied"],
        _links: {
          self: {
            href:
              "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
          },
        },
        id: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
        value: "pivot_default_no_schedule_unoccupied",
      },
      ...getBaseSettings(mode),
    ];
  } else {
    return [
      {
        type: "pivot_timed_override",
        title: "Occupancy",
        options: [
          {
            value: "pivot_default_schedule",
            label: "Unoccupied",
          },
          {
            value: "event",
            label: "Occupied",
          },
          {
            value: "time",
            label: "Occupied",
          },
        ],
        labels: ["Unoccupied", "Occupied", "Occupied"],
        values: ["pivot_default_schedule", "event", "time"],
        _links: {
          self: {
            href:
              "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
          },
        },
        id: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
        value: "pivot_default_schedule",
      },
      ...getBaseSettings(mode),
    ];
  }
};

const getStat = (settings) => {
  return {
    id: settings.id,
    name: settings.name,
    type: "xxl_thermostat",
    icon: {
      name: "thermostat",
      modifiers: [`temperature-${settings.currentTemp}`],
    },
    current_fan_mode: 0,
    current_mode: 3,
    current_run_mode: 0,
    delta: 3,
    features: getFeatures(
      settings.currentTemp,
      settings.status,
      settings.isOccupied,
      settings.occupancy_setpoints,
      settings.isConnected,
      settings.mode
    ),
    operating_state: "System Idle",
    scale: "F",
    setpoints: {
      heat: settings.isOccupied
        ? settings.occupancy_setpoints.preset_heat1
        : settings.occupancy_setpoints.preset_heat2,
      cool: settings.isOccupied
        ? settings.occupancy_setpoints.preset_cool1
        : settings.occupancy_setpoints.preset_cool2,
    },
    supported_fan_modes: { 0: "Auto", 1: "On" },
    supported_modes: { 0: "Off", 1: "Heat", 2: "Cool", 3: "Auto" },
    supported_run_modes: { 0: "Hold Temp", 2: "Energy Save" },
    temperature: settings.currentTemp,
    value: 255,
    settings: getSettings(settings.isOccupied, settings.mode),
  };
};

const dashboardStat = getStat({
  id: 11,
  name: "Springfield",
  currentTemp: 75,
  isOccupied: true,
  status: "Cooling",
  mode: {
    value: "AUTO",
    label: "Auto",
  },
  occupancy_setpoints: {
    preset_heat1: 70,
    preset_cool1: 75,
    preset_heat2: 60,
    preset_cool2: 85,
  },
  isConnected: true,
});

const dashboardStat2 = getStat({
  id: 12,
  name: "Clearwater",
  currentTemp: 76,
  isOccupied: false,
  status: "Cooling",
  mode: {
    value: "COOL",
    label: "Cool",
  },
  occupancy_setpoints: {
    preset_heat1: 70,
    preset_cool1: 75,
    preset_heat2: 60,
    preset_cool2: 75,
  },
  isConnected: true,
});

const groupStatOne = getStat({
  id: 13,
  name: "Show Room",
  currentTemp: 68,
  isOccupied: true,
  status: "Heating",
  mode: {
    value: "AUTO",
    label: "Auto",
  },
  occupancy_setpoints: {
    preset_heat1: 68,
    preset_cool1: 72,
    preset_heat2: 60,
    preset_cool2: 85,
  },
  isConnected: true,
});

const groupStatTwo = getStat({
  id: 14,
  name: "Offices",
  currentTemp: 69,
  isOccupied: true,
  status: "Heating",
  mode: {
    value: "HEAT",
    label: "Heat",
  },
  occupancy_setpoints: {
    preset_heat1: 68,
    preset_cool1: 72,
    preset_heat2: 60,
    preset_cool2: 85,
  },
  isConnected: true,
});

const groupOne = {
  name: "Parker Grove",
  id: 15,
  type: "group",
  icon: [
    { name: "thermostat", modifiers: ["temperature-68"] },
    { name: "thermostat", modifiers: ["temperature-69"] },
  ],
  _links: {
    child: [{ data: groupStatOne }, { data: groupStatTwo }],
  },
};

const addHistoryLink = (model, filterType) => {
  if (!model._links) {
    model._links = {};
  }
  model._links["nexia:history"] = {
    href: `/events?${filterType}_id=${model.id}`,
  };
};

addHistoryLink(dashboardStat, "device");
addHistoryLink(dashboardStat2, "device");
addHistoryLink(groupStatOne, "device");
addHistoryLink(groupStatTwo, "device");

const devices = {
  item_type: MediaType.DEVICE,
  items: [dashboardStat, dashboardStat2, groupOne],
};

const modes = {
  item_type: MediaType.MODE,
  items: [
    {
      id: 21,
      name: "Home",
      current_mode: false,
      icon: "home.png",
      settings: [],
    },
    {
      id: 22,
      name: "Away",
      current_mode: false,
      icon: "away.png",
      settings: [],
    },
    {
      id: 23,
      name: "Vacation",
      current_mode: true,
      icon: "picture.png",
      settings: [],
    },
  ],
};

const events = {
  item_type: MediaType.EVENT,
  _links: {
    page: {
      data: {
        current_page: 1,
        page_count: 1,
      },
    },
  },
};

const location = {
  id: 1,
  name: "Demo",
  _urlMap: {},
  _links: {},
};

location._links.child = [
  { data: modes, type: MediaType.COLLECTION },
  { data: devices, type: MediaType.COLLECTION },
  { data: events, type: MediaType.COLLECTION },
];

function addSelfLink(resource, objectType) {
  let url = objectType || resource.type || "resource";
  if (resource.id != null) {
    url += `/${resource.id}`;
  }
  location._urlMap[url] = resource;
  if (resource._links == null) {
    resource._links = {};
  }
  resource._links.self = { href: url };
}

addSelfLink(events, "events");

_.each(modes.items, (mode) => addSelfLink(mode, "mode"));

_.each(devices.items, (device) => {
  addSelfLink(device);

  _.each(device.settings, (setting) =>
    addSelfLink(setting, `${device._links.self.href}/${setting.type}`)
  );

  _.each(device._links.child, (link) => {
    if (link.data != null) {
      addSelfLink(link.data);
    }
  });
});

export default location;



// WEBPACK FOOTER //
// ./src/models/fixtures/commercial_location.js